/**
 * Users for Dashboard
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { GROUPTYPES_SCHOOL, SCHOOL_ROLE, BETA_MODULES_INBOX } from 'containers/User/constants.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import useMemoryState from 'utils/useMemoryState.js';
import useHashTabs from 'utils/useHashTabs.js';
import Search from 'components/interaction/Search/index.jsx';
import messages from './messages.js';
import UserType from './UserType.jsx';
import RoleType from './RoleType.jsx';
import useGroupTypes from '../Groups/useGroupTypes.js';

function Users(props) {
  const { setMeta } = props;
  const [searchText, setSearchText] = useMemoryState('adminUsersSearch', '');
  const role = useCurrentRole();
  const withInboxes = role.school.betaModules?.includes(BETA_MODULES_INBOX);

  const { memberTypes } = useGroupTypes(GROUPTYPES_SCHOOL);
  const userTypes = memberTypes.map((r) => ({ key: r.id, id: r.name }));
  if (withInboxes) {
    userTypes.push({ key: SCHOOL_ROLE, id: 'role' });
  }
  const { typeId, toTab } = useHashTabs();

  const pageTabs = {
    base: '#',
    tabMessages: messages,
    active: typeId,
    options: userTypes,
  };
  const search = <Search value={searchText} onChange={setSearchText} className="mb-2" />;
  const currentType = userTypes.find((opt) => opt.id === typeId);
  useEffect(() => {
    if (currentType) {
      setMeta({
        title: [messages.users, messages[currentType.id]],
        pageTitle: messages.users,
        pageTabs,
        search,
      });
    }
    if (!typeId || !currentType) {
      toTab(userTypes[0].id);
    }
  }, [typeId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!typeId || !currentType) {
    return null;
  }
  return currentType.key === SCHOOL_ROLE ? <RoleType search={searchText} /> : <UserType type={currentType} search={searchText} />;
}

Users.propTypes = {
  setMeta: PropTypes.func,
};

export default Users;
